import { AuthConfig } from 'angular-oauth2-oidc';
import { enviroment } from 'src/environments/environment';

export const IdpConfig: AuthConfig = {
  issuer: enviroment.fusionAuthConfig.issuer,
  clientId: enviroment.fusionAuthConfig.client_id,
  responseType: 'code',
  redirectUri: window.location.origin + '/home',
  logoutUrl: window.location.origin + '/logout',
  scope: 'openid profile email offline_access',
  timeoutFactor: enviroment.fusionAuthConfig.timeoutFactor,
  strictDiscoveryDocumentValidation: true,
  showDebugInformation: true,
};
